import { render, staticRenderFns } from "./giftList.vue?vue&type=template&id=03b0a70f&scoped=true"
import script from "./giftList.vue?vue&type=script&lang=js"
export * from "./giftList.vue?vue&type=script&lang=js"
import style0 from "./giftList.vue?vue&type=style&index=0&id=03b0a70f&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0a70f",
  null
  
)

export default component.exports